<template>
  <p class="title -t3" v-html="title" />
</template>

<script>
export default {
  props: {
    title: String,
  },
};
</script>

<style lang="scss" scoped>
.title {
  color: #6c2477;
  font-weight: 400;
  line-height: 1.2;
  margin-bottom: 0.5em;
}
</style>
